import { css } from '@emotion/react';
import { Color } from "../../constants";

export const useStyles = (props) => ({
  directoryBackground: css({
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    "& svg": {
      width: 24,
      height: 24,
      color: Color.primary[100],
      marginRight: 12,
    },
  }),
  directorySeparator: css({
    position: "absolute",
    top: 0,
    right: 0,
    width: 0,
    height: 0,
    borderTop: `25px solid ${Color.neutral[0]}`,
    borderLeft: `30px solid transparent`,
    borderBottom: `25px solid ${Color.neutral[0]}`,
    "&::after": {
      content: "''",
      zIndex: 1,
      position: "absolute",
      top: -25,
      borderTop: `25px solid transparent`,
      borderLeft: `30px solid ${Color.neutral[0]}`,
      borderBottom: `25px solid transparent`,
    },
  }),
});
